import React from 'react';
import { Link } from 'react-router-dom';

function ReportCard({ report }) {
  if (!report) return null;

  const {
    title,
    description,
    publicationDate,
    market,
    category,
    thumbnail,
    url,
  } = report;

  const isInternal = url?.startsWith('/');
  const ButtonTag = isInternal ? Link : 'a';
  const buttonProps = isInternal
    ? { to: url }
    : { href: url, target: '_blank', rel: 'noopener noreferrer' };

  return (
    <article className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
      {thumbnail && (
        <img
          src={thumbnail}
          alt=""
          className="h-44 w-full object-cover"
          loading="lazy"
        />
      )}
      <div className="p-5">
        <div className="flex flex-wrap gap-2 text-xs font-semibold uppercase tracking-wide text-blue-700">
          {category && <span>{category}</span>}
          {market && <span>{market}</span>}
        </div>
        <h3 className="mt-3 text-xl font-semibold leading-snug text-slate-950">{title}</h3>
        {publicationDate && (
          <p className="mt-1 text-sm font-medium text-slate-500">{publicationDate}</p>
        )}
        <p className="mt-3 text-sm leading-6 text-slate-600">{description}</p>
        {url && (
          <ButtonTag
            {...buttonProps}
            className="mt-5 inline-flex h-11 items-center justify-center rounded-lg bg-blue-700 px-4 text-sm font-semibold text-white no-underline transition hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-blue-300"
          >
            Read Report
          </ButtonTag>
        )}
      </div>
    </article>
  );
}

export default ReportCard;
